<template>
  <div class="customer-subtype">
    <div class="customer-subtype-container" v-bind:style="{ 'background-color': subtype?.sub_type_color?.rgba_value || '#FFF' }">
      <p class="customer-subtype-name">> {{ subtype.name }}</p>
      <Transition>
        <span v-if="isAdded" id="is-added" class="customer-subtype-added">Added!</span>
      </Transition>
      <Transition>
        <span v-if="isUpdated" id="is-updated" class="customer-subtype-updated">Updated!</span>
      </Transition>
      <div class="customer-subtype-buttons-container customer-subtype-buttons-container-desktop">
      <button @click="removeCustomerType" :key="subtype.id" :id="subtype.id"  type="submit" name="submit" class="btn btn--warning">
        Remove
      </button>
      <button @click="editCustomerType(subtype)" type="submit" name="submit" class="btn btn--primary">
        Edit
      </button>
    </div>
    </div>
    <div class="customer-subtype-buttons-container customer-subtype-buttons-container-mobile">
      <button @click="removeCustomerType" :key="subtype.id" :id="subtype.id"  type="submit" name="submit" class="btn btn--warning">
        Remove
      </button>
      <button @click="editCustomerType(subtype)" type="submit" name="submit" class="btn btn--primary">
        Edit
      </button>
    </div>
  </div>
</template>

<script>
import api from '../../api'

export default {
  name: 'CustomerSubType',
  emits: ['customerSubTypeDeleted', 'customerSubTypeEditingEnabled'],
  props: {
    subtype: {
      type: Object,
      default: null
    },
    added: {
      type: Boolean,
      default: false,
    },
    updated: {
      type: Boolean,
      default: false,
    }
  },
  components: {
  },
  data() {
    return {
      isAdded: this.$props.added,
      isUpdated: this.$props.updated
    }
  },
  methods: {
    removeCustomerType(e) {
      e.preventDefault()
      let params = { type_id: this.subtype.type_id, id: this.subtype.id }
      api.deleteCustomerSubType(params).then(res => {
        console.log(res);
        this.$emit('customerSubTypeDeleted');
      })
    },
    editCustomerType(subType) {
      this.$emit('customerSubTypeEditingEnabled', subType);
    },
    changer() {
      setTimeout(() => {
        if (this.isMobile()) {
          if (document.getElementById("is-updated")) {
            document.getElementById("is-updated").remove();
          }
          if (document.getElementById("is-added")) {
            document.getElementById("is-added").remove();
          }
        } else {
          this.isAdded = false;
          this.isUpdated = false;
        }
      }, 2000);
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
  // afterMount() {

  // },
  mounted() {
    this.$el.scrollRight += 600
    this.changer()
  }
}
</script>
<style scoped>
.customer-subtype {
  display: flex;
  align-items: center;
}

.customer-subtype-name {
  min-width: 100px;
}

.customer-subtype-container {
  display: flex;
  align-items: center;
  padding: 5px;
  justify-content: space-between;
  margin-top: 0.4375rem;
  border: 1px solid #E5E5E5;
  position: relative;
  background: white;
  padding-left: 15px;
  min-width: 100%;
}

.customer-subtype-added,
.customer-subtype-updated {
  color: #089E56;
}

.customer-subtype-buttons-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.customer-subtype-container {

}
.btn {
  min-width: 100px;
  max-width: 110px;
  max-height: 40px;
  margin: 0 5px;
  border: none;
}

.customer-subtype-buttons-container-mobile {
  display: none;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

@media screen and (max-width: 992px) {
  .customer-subtype {
    overflow: scroll;
  }

  .customer-subtype-container {
    padding: 0 10px 0 10px;
    display: flex;
    align-items: center;
  }
  .customer-subtype-buttons-container-mobile {
    display: flex;
  }

  .customer-subtype-buttons-container-desktop {
    display: none;
  }
}
</style>
